import { AbstractPmsApiService } from "./abstract.service";
import { CreditCardPaymentOption } from "../models";

/**
 * @class CreditCardPaymentOptionPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<CreditCardPaymentOption>}
 */
export class CreditCardPaymentOptionPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/credit-card-payment-option';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {CreditCardPaymentOption}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new CreditCardPaymentOption(attributes);
    }
    
    /**
     * @param {Property} property
     * @returns {Promise.<CreditCardPaymentOption>}
     */
    get (property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .get(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {CreditCardPaymentOption} creditCardPaymentOption
     * @param {Property} property
     * @returns {Promise.<CreditCardPaymentOption>}
     */
    updateOrCreate(creditCardPaymentOption, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, creditCardPaymentOption.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/credit-card-payment-option.service.js